import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=62db5c0c&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=ts"
export * from "./Metric.vue?vue&type=script&lang=ts"
import style0 from "./Metric.vue?vue&type=style&index=0&id=62db5c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db5c0c",
  null
  
)

export default component.exports